<template>
  <div :class="['sign-bef', { 'sign-bef--compact': compact }]">
    <div class="sign-bef-editor" v-if="edit">
      <div class="sign-bef-platform">
        <el-select v-model="dataForm.platform_code" placeholder="选择 签约前平台" :clearable="true">
          <el-option
            v-for="item in platformOptions"
            :key="item.code"
            :label="item.name"
            :value="item.code">
          </el-option>
        </el-select>
      </div>
      <div class="sign-bef-fans">
        <el-input v-model="dataForm.fans_total" placeholder="输入 签约前粉丝量" :clearable="true"
                  oninput="value=value.replace(/[^\d^\.^\-]/g,'')"/>
      </div>
      <div>
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="handleAdd">
          添加
        </el-button>
      </div>
    </div>
    <div style='margin-top: 10px;'>
      <el-table :data="tableData" :style="{ width: compact ? '100%' : '80%' }" size="mini" border>
        <el-table-column align="center" label="平台名称" prop="platform_name" :min-width="compact ? 90 : 100">
          <template slot-scope="scope">
            <span>{{ scope.row.platform_name }}</span>
            <!--              <span class="platform_code">/{{ scope.row.platform_code }}</span>-->
          </template>
        </el-table-column>
        <el-table-column align="center" label="签约前粉丝量" prop="fans_total" :min-width="compact ? 120 : 200">
          <template slot-scope='{row}'>
            <span>{{$utils.numberFormat(row.fans_total)}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" :width="compact ? 72 : 110" v-if="edit">
          <template slot-scope="scope">
            <el-link
              type="danger"
              @click="handleDelete(scope.$index, scope.row.id)"
            ><i v-if="!compact" class="el-icon-close"></i>移除</el-link>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: "BefPlatformInfo",
  data() {
    return {
      dataForm: {
        platform_code: '',
        platform_name: '',
        fans_total: '',
      },
      platformOptions: [],
    }
  },
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    edit: {
      type: Boolean,
      default() {
        return false;
      }
    },
    compact: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  computed: {
    tableData() {
      return [...this.data]
    },
  },
  created() {
    this.getPlatforms()
  },
  methods: {
    async getPlatforms() {
      // 获取最新平台信息
      const { list } = await this.$api.getPlatforms()
      this.platformOptions = list
    },
    handleAdd() {
      const code = this.dataForm.platform_code
      const platform = this.platformOptions.find((value) => value.code === code)
      if (!platform) {
        this.$message.warning('请选择签约前平台')
        return
      }
      this.dataForm.platform_name = platform.name

      if (this.tableData.find((value) => value.platform_code === code)) {
        this.$notify.warning(`签约前平台[${ this.dataForm.platform_name }]信息已录入，若要修改，请删除后重新添加！！！`)
        return
      }

      this.tableData.push({ ...this.dataForm })
      this.$emit('currentInfo', this.tableData)
    },
    handleDelete(index) {
      this.tableData.splice(index, 1);
      this.$emit('currentInfo', this.tableData)
    },
  }
}
</script>

<style scoped>
.sign-bef {
  padding: 10px 20px;
  margin-bottom: 20px;
  border: 1px solid rgba(248, 248, 248, 1)
}

.sign-bef-editor {
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
}

.sign-bef--compact {
  padding: 0;
  margin-bottom: 0;
  border: 0;
}

.sign-bef--compact .sign-bef-editor {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) auto;
  gap: 8px;
}

.sign-bef--compact .sign-bef-platform {
  min-width: 0;
  width: auto;
}

.sign-bef--compact .sign-bef-fans {
  min-width: 0;
  width: auto;
}

.sign-bef--compact ::v-deep .el-table__body-wrapper {
  overflow-x: hidden;
}

.sign-bef-editor ::v-deep .el-button {
  min-width: 64px;
  height: 32px;
  padding: 8px 12px;
  border-radius: 4px;
}

.sign-bef--compact ::v-deep .el-table td.el-table__cell,
.sign-bef--compact ::v-deep .el-table th.el-table__cell {
  padding: 5px 0;
}

.sign-bef--compact ::v-deep .el-table th.el-table__cell {
  color: #001327;
  background: #ffffff;
}

.sign-bef--compact ::v-deep .el-link.el-link--danger {
  color: #ff2f78;
}
</style>
